export default __webpack_public_path__ + "static/facebook_dark-e7c5d51e22536bf0ba0eb38c967bb0fc.svg";